/* eslint-disable react/no-array-index-key */
import React from 'react';
import './style.scss';
import { Spinner } from 'react-bootstrap';
import { PlanogramData } from './hooks';
import RenderSixSquareStyle from './RenderSixSquareStyle';
import RenderMenuStyle from './RenderMenuStyle';

interface Props {
  mode: 1 | 2;
  planogramList: PlanogramData[][] | undefined;
  planogramListLoading: boolean;
  // eslint-disable-next-line no-unused-vars
  renderModalDelete: (item: PlanogramData) => React.ReactElement;
  // eslint-disable-next-line no-unused-vars
  renderModalUpdate: (item: PlanogramData) => React.ReactElement;
}

function RenderPlanogram(props: Props) {
  const {
    planogramList, planogramListLoading, mode, renderModalDelete, renderModalUpdate,
  } = props;

  if (planogramList && planogramList.filter((x: PlanogramData[]) => x.length).length) {
    if (mode === 1) {
      return (
        <RenderSixSquareStyle
          planogramList={planogramList}
          renderModalDelete={renderModalDelete}
          renderModalUpdate={renderModalUpdate}
        />
      );
    }
    return (
      <RenderMenuStyle
        planogramList={planogramList}
        renderModalDelete={renderModalDelete}
        renderModalUpdate={renderModalUpdate}
      />
    );
  }
  return (
    <div className="d-flex justify-content-center">
      {planogramListLoading ? (
        <Spinner className="fz-14" animation="border" />
      ) : (
        <div className="text-center">Data Not Found</div>
      )}
    </div>
  );
}

export default React.memo(RenderPlanogram);
